import SSONavigationContent from "organisms/ssoNavigationContent/SSONavigationContent";
import { t } from "i18next";
import { LINK } from "utils/constants/Constants";
import { useEffect, useState } from "react";
//import { useEmployerBillingStatement } from "@sentara-health/sentara-api-hooks-core";
//import { useAuth } from "providers";

const EmployerBillingStatement = () => {
  // ** Uncomment the following lines after LD Implmentation
  // const { user } = useAuth();
  // const { getEmployerBillingStatement } = useEmployerBillingStatement();
  // const [billingStatementSSO, setBillingStatementSSO] = useState("");

  useEffect(() => {
    document.title = t("pageTitleADA.billingStatements");
    //  fetchSSO();
  }, []);

  // ** Uncomment the following function after LD Implmentation
  // const fetchSSO = async () => {
  //   if (user?.loginID) {
  //     const response = await getEmployerBillingStatement({
  //       loginId: user?.loginID,
  //     });
  //     if (response?.data) {
  //       setBillingStatementSSO(response?.data?.Result?.ssoUrl);
  //     }
  //   }
  // };

  return (
    <div id="billingStatementsContent">
      <SSONavigationContent
        header={t("sso.header.BillingStatements")}
        ssoUrl={LINK.EMPLOYER_BILLING_STATEMENT}
        dataTestId="ssoLinkBillingStatements"
        targetName="employerPortalEmployerBillingStatement"
      />
    </div>
  );
};
export default EmployerBillingStatement;
